import { render } from "./PdfParserPage.vue?vue&type=template&id=fbcc3602&scoped=true"
import script from "./PdfParserPage.vue?vue&type=script&lang=js"
export * from "./PdfParserPage.vue?vue&type=script&lang=js"

import "./PdfParserPage.vue?vue&type=style&index=0&id=fbcc3602&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbcc3602"]])

export default __exports__